module.exports = __webpack_public_path__ + "img/code.fb1e6bd8.png";